import {
  RepositoryError,
} from "../repository";

/* カスタム例外 */
class SubscriptionsRepositoryError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = SubscriptionsRepositoryError.getErrorCd();
  }

  static getErrorCd() {
    return "11000";
  }
}

class SubscriptionAlreadyExistsError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = SubscriptionAlreadyExistsError.getErrorCd();
  }

  static getErrorCd() {
    return "11001";
  }
}

class IlligalPaymentIntervalError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = IlligalPaymentIntervalError.getErrorCd();
  }

  static getErrorCd() {
    return "11002";
  }
}

class SubscriptionNotFoundError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = SubscriptionNotFoundError.getErrorCd();
  }

  static getErrorCd() {
    return "11003";
  }
}

export {
  SubscriptionsRepositoryError,
  SubscriptionAlreadyExistsError,
  IlligalPaymentIntervalError,
  SubscriptionNotFoundError,
};
